/**
 * PrimeVue global passthrough configuration.
 * Disables autocorrect, autocapitalize and spellcheck on all input components.
 * This prevents unwanted corrections on bridge-specific terms and usernames.
 */

const inputAttrs = {
    autocorrect: 'off',
    autocapitalize: 'off',
    spellcheck: 'false',
};

export default {
    inputtext: {
        root: inputAttrs,
    },
    textarea: {
        root: inputAttrs,
    },
    password: {
        input: inputAttrs,
    },
    inputnumber: {
        input: inputAttrs,
    },
    autocomplete: {
        input: inputAttrs,
    },
};
